import styled from '@emotion/styled';
import { Icon, NotFound } from '@britishcouncil/react-admin';
import { InvalidRouteIntParamError } from 'const';
import { Header } from 'semantic-ui-react';

interface ErrorFallbackProps {
  error: unknown;
}

export const ErrorPage = ({ error }: ErrorFallbackProps) => {
  if (error instanceof InvalidRouteIntParamError) {
    return <NotFound />;
  }

  return (
    <StyledContainer>
      <Header icon as="h2">
        <Icon name="exclamation triangle" color="red" />
        <Header.Content>Something went wrong</Header.Content>
        <Header.Subheader>An unexpected error occurred.</Header.Subheader>
      </Header>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
